/**
 * Grid Component - Reusable responsive grid layout with theme support
 * Supports different column configurations and gaps
 */

import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

const Grid = ({ 
  children, 
  columns = 'auto-fit', // 'auto-fit', 'auto-fill', or number
  minColumnWidth = '300px',
  gap,
  className = '',
  style = {}
}) => {
  const { theme } = useTheme();
  const getGridColumns = () => {
    if (typeof columns === 'number') {
      return `repeat(${columns}, 1fr)`;
    }
    return `repeat(${columns}, minmax(${minColumnWidth}, 1fr))`;
  };

  const gridStyles = {
    display: 'grid',
    gridTemplateColumns: getGridColumns(),
    gap: gap || theme.spacing.xl,
    ...style
  };

  return (
    <div className={`grid ${className}`} style={gridStyles}>
      {children}
    </div>
  );
};

export default Grid;
